import { render, staticRenderFns } from "./ChatBadoo.vue?vue&type=template&id=46d70bf8&"
import script from "./ChatBadoo.vue?vue&type=script&lang=js&"
export * from "./ChatBadoo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports